// Vuex user module main file
import actions from './actions';
import mutations from './mutations';

const INITIAL_STATE = {
  headers: [],
  templates: [],
  queue: {
    records: [],
    total: 0,
  },
  history: {
    records: [],
    total: 0,
  },
  incoming: {
    records: [],
    total: 0,
  },
  dictionary: {
    status: [],
    type: [],
  },
};

const getters = {
  headersList: state => state.headers,
  templatesList: state => state.templates,
  queueList: state => state.queue,
  historyList: state => state.history,
  incomingList: state => state.incoming,
  statusList: state => state.dictionary.status,
  typeList: state => state.dictionary.type,

};

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  namespaced: true,
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
};

export default Module;
